"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Checks if the browser is IE11.
var useIsIE = function () {
    return 'documentMode' in window.document;
};
exports.default = useIsIE;
